import { useState } from 'react';
import styles from '../adminPage.module.css';

const ToolModal = ({ isOpen, toolName, onClose, onExecute, isLoading, message }) => {
    const [params, setParams] = useState({});

    const handleExecute = () => {
        onExecute(toolName, params);
        setParams({});
    };

    if (!isOpen) return null;

    const renderInputs = () => {
        switch (toolName) {
            case 'Bulk Operations':
                return (
                    <>
                        <div className={styles.formGroup}>
                            <label>Action:</label>
                            <select
                                value={params.action || ''}
                                onChange={(e) => setParams({ ...params, action: e.target.value })}
                            >
                                <option value="">Select action</option>
                                <option value="activate">Activate Users</option>
                                <option value="deactivate">Deactivate Users</option>
                                <option value="makeAdmin">Make Admin</option>
                                <option value="removeAdmin">Remove Admin</option>
                                <option value="delete">Delete Users</option>
                            </select>
                        </div>
                        <div className={styles.formGroup}>
                            <label>User IDs (comma-separated):</label>
                            <input
                                type="text"
                                placeholder="1,2,3,4,5"
                                value={params.userIds?.join(',') || ''}
                                onChange={(e) => setParams({ ...params, userIds: e.target.value.split(',').map(id => parseInt(id.trim())).filter(Boolean) })}
                            />
                        </div>
                    </>
                );

            case 'Mass Email':
                return (
                    <>
                        <div className={styles.formGroup}>
                            <label>User IDs (comma-separated):</label>
                            <input
                                type="text"
                                placeholder="1,2,3"
                                value={params.userIds?.join(',') || ''}
                                onChange={(e) => setParams({ ...params, userIds: e.target.value.split(',').map(id => parseInt(id.trim())).filter(Boolean) })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Subject:</label>
                            <input
                                type="text"
                                placeholder="Email subject"
                                value={params.subject || ''}
                                onChange={(e) => setParams({ ...params, subject: e.target.value })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Body:</label>
                            <textarea
                                placeholder="Email content"
                                rows="4"
                                value={params.body || ''}
                                onChange={(e) => setParams({ ...params, body: e.target.value })}
                            />
                        </div>
                    </>
                );

            case 'Push Notifications':
                return (
                    <>
                        <div className={styles.formGroup}>
                            <label>User IDs (comma-separated):</label>
                            <input
                                type="text"
                                placeholder="1,2,3"
                                value={params.userIds?.join(',') || ''}
                                onChange={(e) => setParams({ ...params, userIds: e.target.value.split(',').map(id => parseInt(id.trim())).filter(Boolean) })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Title:</label>
                            <input
                                type="text"
                                placeholder="Notification title"
                                value={params.title || ''}
                                onChange={(e) => setParams({ ...params, title: e.target.value })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Message:</label>
                            <textarea
                                placeholder="Notification message"
                                rows="4"
                                value={params.message || ''}
                                onChange={(e) => setParams({ ...params, message: e.target.value })}
                            />
                        </div>
                    </>
                );

            case 'Announcements':
                return (
                    <>
                        <div className={styles.formGroup}>
                            <label>Title:</label>
                            <input
                                type="text"
                                placeholder="Announcement title"
                                value={params.title || ''}
                                onChange={(e) => setParams({ ...params, title: e.target.value })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Content:</label>
                            <textarea
                                placeholder="Announcement content"
                                rows="4"
                                value={params.content || ''}
                                onChange={(e) => setParams({ ...params, content: e.target.value })}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>Type:</label>
                            <select
                                value={params.type || 'info'}
                                onChange={(e) => setParams({ ...params, type: e.target.value })}
                            >
                                <option value="info">Info</option>
                                <option value="warning">Warning</option>
                                <option value="success">Success</option>
                                <option value="error">Error</option>
                            </select>
                        </div>
                    </>
                );

            case 'Cleanup':
                return (
                    <div className={styles.formGroup}>
                        <label>Inactive for (months):</label>
                        <input
                            type="number"
                            placeholder="6"
                            min="1"
                            value={params.months || ''}
                            onChange={(e) => setParams({ ...params, months: parseInt(e.target.value) })}
                        />
                    </div>
                );

            case 'Archive Data':
                return (
                    <div className={styles.formGroup}>
                        <label>Archive data older than (years):</label>
                        <input
                            type="number"
                            placeholder="1"
                            min="1"
                            value={params.yearsOld || ''}
                            onChange={(e) => setParams({ ...params, yearsOld: parseInt(e.target.value) })}
                        />
                    </div>
                );

            case 'Activity Logs':
                return (
                    <div className={styles.formGroup}>
                        <label>User ID:</label>
                        <input
                            type="number"
                            placeholder="Enter user ID"
                            value={params.userId || ''}
                            onChange={(e) => setParams({ ...params, userId: parseInt(e.target.value) })}
                        />
                    </div>
                );

            case 'Suspend Users':
                return (
                    <div className={styles.formGroup}>
                        <label>User ID to suspend:</label>
                        <input
                            type="number"
                            placeholder="Enter user ID"
                            value={params.userId || ''}
                            onChange={(e) => setParams({ ...params, userId: parseInt(e.target.value) })}
                        />
                    </div>
                );

            case 'Maintenance':
                return (
                    <>
                        <div className={styles.formGroup}>
                            <label>Enable Maintenance Mode:</label>
                            <select
                                value={params.enabled === true ? 'true' : params.enabled === false ? 'false' : ''}
                                onChange={(e) => setParams({ ...params, enabled: e.target.value === 'true' })}
                            >
                                <option value="">Select...</option>
                                <option value="true">Enable</option>
                                <option value="false">Disable</option>
                            </select>
                        </div>
                        <div className={styles.formGroup}>
                            <label>Maintenance Message (optional):</label>
                            <textarea
                                placeholder="We are performing scheduled maintenance..."
                                rows="3"
                                value={params.message || ''}
                                onChange={(e) => setParams({ ...params, message: e.target.value })}
                            />
                        </div>
                    </>
                );

            default:
                return <p>Click Execute to run this tool.</p>;
        }
    };

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <h2>{toolName}</h2>
                    <button className={styles.modalClose} onClick={onClose}>×</button>
                </div>

                <div className={styles.modalBody}>
                    {message && (
                        <div className={message.includes('Error') ? styles.errorMessage : styles.successMessage}>
                            {message}
                        </div>
                    )}
                    {!message && renderInputs()}
                </div>

                <div className={styles.modalFooter}>
                    <button
                        className={styles.btnCancel}
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Close
                    </button>
                    {!message && (
                        <button
                            className={styles.btnExecute}
                            onClick={handleExecute}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Processing...' : 'Execute'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ToolModal;
